module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./NewsDetailView.js"));
	}, "NewsDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NewsDetailView!./src/pages/Shop/Home/News/NewsDetail/NewsDetailView.js
// module id = 933
// module chunks = 431